import { memo } from 'react';
import _ from 'lodash';

import DealsStatistics from './DealsStatistics.react';
import ReservationManipulation from './ReservationManipulation.react';
import RoomGroups, { cardCountOf, displayGroupKeyOf } from './RoomGroups.react';

const DealsStatisticsSection = ({
	hotelDeals,
	hotel,
	reservationManipulation,
	profile,
	displayDebugging,
	dynamicPriceIdFilter,
	onShowSupersededDeals,
	onFilterByDynamicPriceId,
	onInitStatusChange,
	onRecheckChange,
	onPriceChange,
	onRoomDetails,
}) => {
	const countByRoomGroup = _.countBy(hotelDeals, 'room_group');
	const numGroups = Object.keys(countByRoomGroup).length;
	const numHotelDeals = hotelDeals ? Object.keys(hotelDeals).length : 0;
	const supersededNum = hotelDeals ? hotelDeals.filter((d) => d.superseded).length : 0;
	const numContainers = _.uniq((hotelDeals || []).map(displayGroupKeyOf)).length;
	const numCards = _.sum(Object.values(_.groupBy(hotelDeals || [], displayGroupKeyOf)).map(cardCountOf));
	const numCatalogRooms = Array.isArray(hotel && hotel.rooms) ? hotel.rooms.length : 0;

	return (
		<div>
			<DealsStatistics
				deals={numHotelDeals}
				groups={numGroups}
				containers={numContainers}
				cards={numCards}
				catalog_rooms={numCatalogRooms}
				superseded_num={supersededNum}
				showSupersededDealsCallback={onShowSupersededDeals}
				display_debugging={displayDebugging}
				onFilterByDynamicPriceId={onFilterByDynamicPriceId}
				dynamicPriceIdFilter={dynamicPriceIdFilter}
			/>
			<RoomGroups deals={hotelDeals} hotel={hotel} profile={profile} onRoomDetails={onRoomDetails} />
			<ReservationManipulation
				profile={profile}
				reservation_manipulation={reservationManipulation}
				onInitStatusChange={onInitStatusChange}
				onRecheckChange={onRecheckChange}
				onPriceChange={onPriceChange}
			/>
		</div>
	);
};

export default memo(DealsStatisticsSection);
